import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

import { useSmartLists } from './use-smart-lists';

export const useCreateSmartListAllowed = () => {
  const smartLists = useSmartLists({ excludeFrozen: true });

  const { allowed, enforced, limit } = usePremiumFeatureAllowed(
    LimitKeys.CreateSmartList,
    {
      total: smartLists.length,
    },
  );

  return {
    allowed,
    enforced,
    limit,
    total: smartLists.length,
  };
};
